import { render } from "./CookieSettings.vue?vue&type=template&id=459f8be5&scoped=true"
import script from "./CookieSettings.vue?vue&type=script&lang=js"
export * from "./CookieSettings.vue?vue&type=script&lang=js"

import "./CookieSettings.vue?vue&type=style&index=0&id=459f8be5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-459f8be5"]])

export default __exports__